import React from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { Col } from 'reactstrap';
import Repeater from '@Utils/Repeater';
import OptionComponent from '@Components/builder/unit-option/option.component';
import { OptionView } from '@Selectors/builder/myArmyList/make/unit/edit/OptionView';
import { UnitOptionGroupView } from '@Selectors/builder/myArmyList/make/view/unit-option-group.view';

export interface UnitOptionGroupComponentProps {
  allOptions: OptionView[];
  unitOptionGroup: UnitOptionGroupView;
}

const UnitOptionGroupComponent: React.FC<Props> = ({ allOptions, unitOptionGroup}) => {

  if (!unitOptionGroup.options.length)
    return (<></>);

  return (
    <Col xs={12} md={6} xl={4}>
      <h4>{unitOptionGroup.name}</h4>
      <div className="options">
        <Repeater data={unitOptionGroup.options} indexPrefix="option">
          {
            (item: OptionView) =>
              <OptionComponent allOptions={allOptions} unitOptionGroup={unitOptionGroup} option={item} />
          }
        </Repeater>
      </div>
    </Col>
  );
};

const mapStateToProps = (state: AppState, owprops: UnitOptionGroupComponentProps) => ({
  unitOptionGroup: owprops.unitOptionGroup,
  allOptions: owprops.allOptions,
});

const mapDispatchToProps = (_: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(UnitOptionGroupComponent);

type Props = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  UnitOptionGroupComponentProps;
